export default __webpack_public_path__ + "static/media/banner-tablets.a962057c.png";